module.exports = __webpack_public_path__ + "7416d8f24bd1468510a230d71cbe15de.MP3";